
<div class="grid lg:grid-cols-4 grid-cols-5 h-[44px]">
    <div class="row flex items-center lg:col-span-2 col-span-3 text-[rgba(0,106,152,1)] text-[20px]">
        <a href="{{this.absoluteMediaUriService.getAbsoluteMediaUri('/auction/search/search.action?search=&savedSearchId=' + search?.id + '&query.query=' + search?.query)}}" >
            {{search?.name}}
        </a>
    </div>
    <div class="flex justify-center items-center">
        <p-toggleswitch class="scale-75 " [(ngModel)]="search!.receiveEmail" (onChange)="onCheckboxChange(search!)"/>
    </div>
    <div class="flex justify-center items-center">
         <fa-icon [icon]="faTrashCan" class="text-[25px] text-[rgba(110,110,110,1)]" (click)="confirmFunc(search!)"></fa-icon>
    </div>

</div>
<div class="h-[1px] w-full bg-[rgba(223,231,239,1)]"></div>